import { render, staticRenderFns } from "./t-report-option-card.vue?vue&type=template&id=084cf4b0&"
import script from "./t-report-option-card.vue?vue&type=script&lang=js&"
export * from "./t-report-option-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports